module.exports = __webpack_public_path__ + "img/share-tips.1bcae821.png";